/** Aviso âmbar com a mensagem do servidor. */
export function AvisoPluggyDesligada({ mensagem, className = '' }: { mensagem: string; className?: string }) {
  return (
    <div role="status" className={`flex items-start gap-2 rounded border border-warning/50 bg-warning/10 p-3 text-13 text-warning ${className}`}>
      <i className="ri-error-warning-line mt-0.5" aria-hidden />
      <div>
        <p>{mensagem}</p>
        <p className="mt-1 text-2xs text-muted">Seus dados já importados continuam aqui e o app funciona normalmente, sem a conexão.</p>
      </div>
    </div>
  )
}
